// Theme-aware tooltip surface — a very light tint of the active theme: a soft
// near-white in light mode, and a lifted lighter-than-background surface in
// dark mode. Returned colors are applied as INLINE styles so they always win
// over a component's base tooltip background (e.g. shadcn's `bg-primary`).
export function getTooltipTheme() {
  const isDark = typeof document !== 'undefined' && document.documentElement.classList.contains('dark');
  return isDark
    ? { bg: '#2a3346', fg: '#e8edf5', sub: '#9aa6bd', hint: '#7c8aa6', border: '#3c475f' }
    : { bg: '#f8fafc', fg: '#0f172a', sub: '#64748b', hint: '#94a3b8', border: '#e2e8f0' };
}
